export function getElementDataAttribute(elt, attributeName, defaultValue = "") {
    return (elt === null || elt === void 0 ? void 0 : elt.getAttribute(`data-${attributeName}`)) || defaultValue;
}
export function setElementDataAttribute(elt, attributeName, attributeValue) {
    return elt === null || elt === void 0 ? void 0 : elt.setAttribute(`data-${attributeName}`, attributeValue);
}
